import {
  QUERY_FETCH_LATEST_RESOURCES_WITH_FILTERS,
  LatestResourcesWithFiltersQuery,
  LatestResourcesWithFiltersQueryVariables,
} from '@edwin-group/cj-graphql';
import { useMemo } from 'react';
import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { buildResourcesQueryVariables, SearchFilters } from '../utils/query-variables';

export const useResourcesSearch = (filters: SearchFilters, shouldSkip: boolean) => {
  const queryVariables = useMemo(() => buildResourcesQueryVariables(filters), [filters]);

  const {
    data: result,
    fetchMore,
    isInitialLoading,
  } = useQueryCacheAndNetwork<LatestResourcesWithFiltersQuery, LatestResourcesWithFiltersQueryVariables>(
    QUERY_FETCH_LATEST_RESOURCES_WITH_FILTERS,
    {
      variables: queryVariables,
      skip: shouldSkip,
    },
  );

  const resourcesList = result?.resources?.data;

  return {
    resourcesList,
    fetchMore,
    isLoading: isInitialLoading,
    queryVariables,
    result,
  };
};
